// 桩配置执行结果
import React, { Component } from "react";
import { Table } from "antd";
import fetchHandler from "@/fetch/fetchHandler";
import { getStubCfgResult } from "@/fetch/fetchApi";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class TaskExecuteResult extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.taskExecuteResult;
    this.state = {
      result: [],
    };
    this.query = {};
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.init();
  }

  componentWillMount() {
    this.getStubCfgResult(this.props.taskName, this.props.taskId);
  }

  init() {
    this.query = {
      page: "1",
      pagecount: "10",
    };
    this.tableColumns = [
      {
        title: this.internationalization.title1, // '终端编号',
        dataIndex: "stubId",
        key: "stubId",
      },
      {
        title: "结果",
        dataIndex: "result",
        key: "result",
        align: "center",
        render: (value) => {
          switch (value) {
            case 0:
              return <div style={{ color: "green" }}>{this.internationalization.msg1}</div>;
            case 1:
              return <div style={{ color: "red" }}>{this.internationalization.msg2}</div>;
            case 2:
              return <div style={{ color: "red" }}>{this.internationalization.msg3}</div>;
            default:
              return "--";
          }
        },
      },
    ];
  }

  getStubCfgResult(taskName, taskId) {
    fetchHandler(getStubCfgResult, {
      taskName: taskName,
      taskId: taskId,
    }).then((data) => {
      if (data) {
        this.setState({
          result: data.data,
        });
      }
    });
  }

  render() {
    const content = (
      <div className="sc-page-content">
        <div className="page-panel">
          <Table
            dataSource={this.state.result}
            columns={this.tableColumns}
            footer={this.state.result && this.state.result.length ? () => <div></div> : null}
            className="sc-table"
          />
        </div>
      </div>
    );
    return content;
  }
}

export default injectIntl(TaskExecuteResult);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/taskExecuteResult.js